
/*
Author: Vinod
Date: 24/01//2020
Issue Description: Monthly TDS Report.
search_string: PL_2410
*/

/*
Author: Vinod
Date: 08/04/2020
Issue Description: month value change in request body.
search_string: PL_3048
*/

/*
Author: Vinod
Date: 16/04/2020
Issue Description: Change in implementation to download reports for more than 100 employees.
search_string: PL_3064
*/

/*
Author: Samir
Date: 16/04/2020
Issue Description: download IT form16 report for employee
search_string: PL_3223
*/
<template>
  <div class="main-container">
    <breadcrumb :list="breadcrumbList" />
    <tl-header type="h3" class="head">My Reports</tl-header>
    <toast-message
      :message="errmsg"
      type="error"
      :isToastEnable="toast"
      @close="(val) => toast = val"
    />
    <pop-up-message
          v-if="showSuccessBulkUploadMsg"
          message="We will provide you with an Email as soon as the report has been successfully downloaded."
          btnText="Back"
          @back="backUpload"
        ></pop-up-message>
        <pop-up-message
          v-if="showSuccessDownload"
          message="Successfully Downloaded."
          btnText="Back"
          @back="backUpload"
        ></pop-up-message>
    <!-- <div class="link" v-on:click="customreport">Create Custom Report</div> -->
    <div class="permission-alert-msg" v-show="!(ifTeamleaderAnchorPermission || ifEmployee || ifHr)">
      You have only view permission.
    </div>
    <div class="type" :disabled="!(ifTeamleaderAnchorPermission || ifEmployee || ifHr)">
      <tl-select
        label="Report Type"
        :options="reportType"
        @change="(val)=>rpttypechanged(val)"
      />
      <tl-select
        v-if="this.reptype"
        :label="subReportType"
        :options="subreptypeoption"
        v-model="subreptype"
        @change="(val)=>subreptype=val"
      />
      <btn v-if="this.reptype"  :text="reptype === 'Payroll' ? 'Salary Register Logs' : 'IT Computation Logs'" 
      style="margin-top: 15px; margin-left: 57%;" type="primary" @click="customreport()"  />
    </div>
    <loading-animation v-show="showLoader"></loading-animation>
    <div v-if="this.subreptype && this.subreptype != '24Q Report' || 'Salary'">
      <div class="header header3 subtype">
        <span class="text">{{this.subreptype}}</span>
      </div>
    
      <!-- Employee search input box and show in card -->
      <div class="searchclass margin-bot-22" v-if="this.subreptype == 'Annual Salary Report'">
          <div class="block-width-no-use">
            <search-dropdown v-if="!showEmpDetails"
                placeholder="Search Employee"
                :employeeData="employeeList"
                :clearRequired="true"
                @getList="searchEmployeesByName($event)"
                @empselected="(emp)=>selectedEmp(emp)"/>
          </div>
          <selected-employee-card v-if="showEmpDetails"
            :empName="datas.first_name"
            :empId="datas.code"
            :dates="datas.rlopdates"
            :empMail="datas.email_id"
            @click="close">
            <!-- <template v-slot:rowcontent="slotprops">
            </template> -->
          </selected-employee-card>
      </div>
      <!-- End here -->

      <div class="type" :disabled="!(ifTeamleaderAnchorPermission || ifEmployee || ifHr)">
        <tl-select
          label="Financial Year"
          labelText="name"
          :options="financialYearList"
          v-model="financialYear"
          @change="(val)=>{financialYear=val; getFinancialYearMonths();}"
        />
        <div v-if="this.subreptype != 'Form16' && this.subreptype !=  'Annual Salary Report'"><tl-select
          label="Month"
          labelText="name"
          :options="monthOptions"
          @change="(val)=>{month=val; updateFinancialYear(val);}"
        /></div>
      </div>
      <div>
        <div v-if="this.subreptype=='Salary Register'" class="margintop-32">
          <h4  class="employeeTitle">Enter Employee Codes</h4>
          <textarea class="form-control custom-textarea margintop-16 width-480" rows="15"  name="selectEmp" v-model="details"
            placeholder="Enter employee codes seperated by comma ( , )"/>
        </div>
      </div>
      <!-- <div v-if="this.subreptype && this.subreptype != 'Head Count Reports'">
        <div class="row margin-t-m">
          <div class="col-3 padding-l-n">
            <tl-select
              label="Paygroup"
              labelText="name"
              v-model="paygroup"
              :multiple="true"
              :options="paygroupOptions"
              @change="(val)=>paygroup = val"
            />
          </div>
          <div class="col-3">
            <tl-select
              label="Criteria"
              v-model="criteria"
              :options="criteriaOptions"
              @change="(val) => {criteria = val;onSelectCriteria(val)}"
            />
          </div>
          <div class="col-3" v-if="subCriteriaLabel">
            <tl-select
              :label="subCriteriaLabel"
              labelText="name"
              v-model="subcriteria"
              :multiple="true"
              :options="subCriteriaList"
              @change="(val)=>subcriteria = val"
            />
          </div>
          <div class="col-3" v-if="subCriteriaLabel">
            <btn text="Apply Filters" type="secondary" class="btn-filter" @click="applyFilter"></btn>
          </div>
        </div>
        <div class="header header2">
          <div class="line"></div>
        </div>
        <div class="employeecard d-pending">
          @click="gotoEmployees"
          <span class="emptext">{{empcount}}</span>
          <span class="empselect">Employees Selected</span>
        </div>
      </div> -->
      <tl-accordion class="employee" v-if="subreptype == 'Salary Register V2' || this.subreptype == 'Employee Master' || this.subreptype == 'Demo Report' || this.subreptype == 'Salary Register'" headerName="Employee Info" :active="true">
       <template v-slot:accordionHeader>
        <div class="heading">
          <span>Employee Details</span>
        </div>
       </template>
       <template v-slot:accordionBody>
        <tl-accordion v-if="subreptype == 'Salary Register V2'" class="employee" headerName="Employee Info" :active="true">
         <template v-slot:accordionHeader>
        <div class="subHeading">
          <span>Employee  Information</span>
        </div>   
       </template>
       <template v-slot:accordionBody>
         <div class="col-12">
              <span class="filter-text" @click="selectAll(true)" v-if="selectTitle=='Select All'">{{selectTitle}}</span>
              <span class="filter-text" @click="selectAll(false)" v-else>{{selectTitle}}</span>    
            </div> 
         <div class="row">
          <div class="col-12">
           <div class="selectedComp">
            <div v-for="(data,index) in employeeInfoList" :key="index">
              <div :class="[data.checked ? 'selected' : 'rect']" @click="select(data.checked,data)">
                <button>
                  <span class="tag-title">{{data.label}}</span>
                </button>
              </div>
            </div>
           </div>
          </div>
         </div>
         </template>
         </tl-accordion>
         <tl-accordion v-if="subreptype !== 'Salary Register V2'" class="employee" headerName="Employee Info" :active="true">
         <template v-slot:accordionHeader>
        <div class="subHeading">
          <span>Employee Personal Information</span>
        </div>   
       </template>
       <template v-slot:accordionBody>
         <div class="col-12">
              <span class="filter-text" @click="selectAll(true)" v-if="selectTitle=='Select All'">{{selectTitle}}</span>
              <span class="filter-text" @click="selectAll(false)" v-else>{{selectTitle}}</span>    
            </div> 
         <div class="row">
          <div class="col-12">
           <div class="selectedComp">
            <div v-for="(data,index) in employeeInfoList" :key="index">
              <div :class="[data.checked ? 'selected' : 'rect']" @click="select(data.checked,data)">
                <button>
                  <span class="tag-title">{{data.label}}</span>
                </button>
              </div>
            </div>
           </div>
          </div>
         </div>
         </template>
         </tl-accordion>
             <tl-accordion v-if="subreptype !== 'Salary Register V2'" class="employee" headerName="Employee Info" :active="true">
         <template v-slot:accordionHeader>
        <div class="subHeading">
          <span>Employee Official Information</span>
        </div>
       </template>
       <template v-slot:accordionBody>
         <div class="row">
          <div class="col-12">
           <div class="selectedComp">
            <div v-for="(data,index) in employeeInfoListOfficial" :key="index">
              <div :class="[data.checked ? 'selected' : 'rect']" @click="select(data.checked,data)">
                <button>
                  <span class="tag-title">{{data.label}}</span>
                </button>
              </div>
            </div>
           </div>
          </div>
         </div>
         </template>
         </tl-accordion> 
         <div class="row">
          <div class="col-12 mt-35">
           <p><b>Selected Fields:</b></p>
          </div>
          <div class="col-12">
           <div class="selectedComp">
              <div v-for="(item,index) in checkedArray" :key="index">
                <div class="selected">
                 <button>
                  <span class="close-title">{{item.label}}</span>
                  <img src="@/assets/close_cross_circle.svg" @click="removeTag(item.value, item)" />
                 </button>
                </div>
              </div>
           </div>
          </div>
         </div>
       </template>
      </tl-accordion>
      <bottom-action-container>
        <template  v-if="!disableDownloadButton" slot="end">
          <!-- <btn text="Download" style=" margin-right: 10px;" type="primary" @click="downloadReport()" /> -->
          <btn-grp>
            <btn text="Reload" style="margin-right: 10px;" type="primary" @click="checkPayroll()" />
          </btn-grp>
        </template>
        <template v-if="subreptype == 'IT Computation' || subreptype == 'Salary Register'" slot="end">
          <!-- <btn text="Download" style=" margin-right: 10px;" type="primary" @click="downloadReport()" /> -->
          <btn-grp :disabled="!(ifTeamleaderAnchorPermission || ifEmployee || ifHr)">
            <btn :disabled=!disableDownloadButton text="Download" style="margin-right: 10px;" type="primary" @click="downloadReport()" />
          </btn-grp>
          <!-- <btn-grp :disabled="!(ifTeamleaderAnchorPermission || ifEmployee || ifHr)">
            <btn text="Process & Download" style=" margin-right: 10px;" type="primary" @click="ProcessDownloadReport()" />
          </btn-grp> -->
          <!-- <btn-grp :disabled="!(ifTeamleaderAnchorPermission || ifEmployee || ifHr)">
          <button
                                class="fnfbtn"
                                :disabled="!(ifTeamleaderAnchorPermission || ifEmployee || ifHr)"
                                @click="ProcessDownloadReport()"
                                text="Download" type="primary"
                            >Download</button>
                          </btn-grp> -->
        </template>
        <template v-if="subreptype == 'Salary Register V2' || subreptype == 'IT Computation V2'" slot="end">
          <btn-grp :disabled="!(ifTeamleaderAnchorPermission || ifEmployee || ifHr)">
          <button
                                class="fnfbtn"
                                :disabled="!(ifTeamleaderAnchorPermission || ifEmployee || ifHr)"
                                @click="subreptype=='Salary Register V2'?downloadReport() : ProcessDownloadReport()"
                                text="Download" type="primary"
                            >Download</button>
                          </btn-grp>
        </template>
      </bottom-action-container>
    </div>

    <div v-if="this.subreptype && this.subreptype == '24Q Report'">
      <div class="header header3 subtype">
        <span class="text">{{this.subreptype}}</span>
      </div>
      <twenty-four-q-report></twenty-four-q-report>
    </div>

    <pop-up-message
      v-if="showErrorPopup"
      popupHeaderMessage="Warning"
      :popupType="`Warning`"
      message="No Employee Master Data Found."
      btnText="Back"
      @back="showErrorPopup=!showErrorPopup"
    />
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";
import SearchDropdown from "@/components/TlSearchDropdown.vue";
import twentyFourQReport from "./twentyFourQReport.vue";
import { monthOptionsObj, criteriaObj } from "../../../../../apis/constants.js";
import SelectedEmployeeCard from "@/components/dashboard/selectedEmployeeCard.vue";
export default {
  data() {
    return {
      breadcrumbList: [
        {
          name: "Reports",
          url: `/dashboard/${this.$route.params.entity_index}/reports/reportsDashboard`
        },
        {
          name: "My Reports",
          url: `/dashboard/${this.$route.params.entity_index}/reports/reportsDashboard/myReports`
        }
      ],
      disableDownloadButton:true,
      details:"",
      reptype: "",
      showSuccessBulkUploadMsg: false,
      showSuccessDownload: false,
      subreptype: "",
      financialYear: "",
      month: "",
      customEmpList: [],
      employeeData: [],
      toast: false,
      errmsg: "",
      empcount: 0,
      monthOptions: [],
      monthsList: monthOptionsObj.monthListForFinancialYear,
      financialYearList: [],
      criteriaOptions: criteriaObj.reportCriteria,
      monthArray: monthOptionsObj.onlyMonths,
      subCriteriaLabel: "",
      subCriteriaList: [],
      paygroupOptions: [],
      paygroup: [],
      criteria: null,
      subcriteria: [],
      dropdownList: [],
      statusLabel: "",
      statusOptions: "",
      request: {},
      instance:{
          empId:'00b87632-c9ad-4e20-9a07-5fef97cbd120',
          financialYear:'2019-2020',
          page:'1'
      },
      // reportType:['Bank','Payroll','Statutory','IncomeTax','Salary','Employee Exit Reports'],
      reportType:['Payroll','IncomeTax',],
      reportosValue: false,
      role: "",
      subReportType: "",
      showErrorPopup: false,
      empStatus: "",
      showEmpDetails: false,
      employeeList: [],
      datas: {},
      employee_id: "",
      selectTitle: 'Select All',
      selectedAll: false,
      checkedArray:[],
      additionalFieldsObj: {},
      additionalFieldsArray: [],
      additionalFieldsArrayTwo:[],
      employeeInfoListOfficial: [
        {
          label: "DOJ",
          value: "date_of_joining",
          checked: false,
        },
        {
          label: "DEPARTMENT",
          value: "department",
          checked: false
        },
        {
          label: "EMAIL ID",
          value: "email_id",
          checked: false
        },
        {
          label: "GRADES",
          value: "grades",
          checked: false
        },
        {
          label: "INITIATION DATE",
          value: "initiation_date",
          checked: false
        },
        {
          label: "LAST WORKING DATE",
          value: "last_working_date",
          checked: false
        },
        {
          label: "JOB TYPE",
          value: "job_type",
          checked: false
        },
        {
          label: "DESIGNATION",
          value: "designation",
          checked: false
        },
        {
          label: "LOCATION",
          value: "location",
          checked: false
        },
        {
          label: "LEVEL",
          value: "level",
          checked: false
        },
        {
          label: "COST CENTER",
          value: "cost_center",
          checked: false
        },
        {
          label: "BAND",
          value: "band",
          checked: false
        },
        {
          label: "EMPLOYEE CATEGORY",
          value: "employee_category",
          checked: false
        },
        {
          label: "SKILL",
          value: "skill",
          checked: false
        },
        {
          label: "PAYMENT MODE",
          value: "payment_mode",
          checked: false
        },
        {
          label: "CONFIRMATION PERIOD",
          value: "confirmation_period",
          checked: false
        },
        {
          label: "COST TO COMPANY",
          value: "cost_to_company",
          checked: false
        },
        {
          label: "ANNUAL VP",
          value: "annual_vp",
          checked: false
        },
        {
          label: "FLEXIBLE BENEFIT PLAN",
          value: "flexible_benefit_plan",
          checked: false
        },
        {
          label: "REPORTING MANAGER",
          value: "sec_reporting_manager",
          checked: false
        },
        {
          label: "ENABLE ESS",
          value: "enable_ess",
          checked: false
        },
      ],
      employeeInfoList: [
        {
          label: "CODE",
          value: "code",
          checked: true
        },
        {
          label: "NAME",
          value: "name",
          checked: true
        },
        {
          label: "DOB",
          value: "dob",
          checked: false
        },
        {
          label: "GENDER",
          value: "gender",
          checked: false
        },
        {
          label: "FATHER'S NAME",
          value: "father_name",
          checked: false
        },
        {
          label: "MOTHER'S NAME",
          value: "mother_name",
          checked: false
        },
        {
          label: "BANK NAME",
          value: "bank_name",
          checked: false
        },
        {
          label: "PASSPORT NO.",
          value: "passport_number",
          checked: false
        },
        {
          label: "PASSPORT EXPIRY DATE",
          value: "passport_expiry_date",
          checked: false
        },
        {
          label: "PF",
          value: "employee_has_pf",
          checked: false
        },
        {
          label: "PF NO.",
          value: "pf_number",
          checked: false
        },
        {
          label: "PF DATE",
          value: "pf_date",
          checked: false
        },
        {
          label: "EMPLOYEE PF CONTRIBUTION RULE",
          value: "employee_pf_contribution_rule",
          checked: false
        },
        {
          label: "EMPLOYER PF CONTRIBUTION RULE",
          value: "employer_pf_contribution_rule",
          checked: false
        },
        {
          label: "PAN NO.",
          value: "pan",
          checked: false
        },
        {
          label: "ESI",
          value: "employee_has_esi",
          checked: false
        },
        {
          label: "ESI NO.",
          value: "esi_number",
          checked: false
        },
        {
          label: "LWF",
          value: "employee_has_lwf",
          checked: false
        },
        {
          label: "PT",
          value: "employee_has_pt",
          checked: false
        },
        {
          label: "BANK ACCOUNT NO.",
          value: "bank_account_number",
          checked: false
        },
        {
          label: "IFSC CODE",
          value: "ifsc_code",
          checked: false
        },
        {
          label: "ACCOUNT HOLDER'S NAME",
          value: "account_holder_name",
          checked: false
        },
        {
          label: "BRANCH NAME",
          value: "branch_name",
          checked: false
        },
        {
          label: "MARITAL STATUS",
          value: "marital_status",
          checked: false
        },
        {
          label: "ADHAR NO.",
          value: "adhar_number",
          checked: false
        },
        {
          label: "EMERGENCY CONTACT NO.",
          value: "emergency_contact_number",
          checked: false
        },
        {
          label: "PHONE NO.",
          value: "phone_number",
          checked: false
        },
        {
          label: "ADDRESS 1 (PERMANENT ADDRESS)",
          value: "address_1",
          checked: false
        },
        {
          label: "ADDRESS 2 (COMMUNICATION ADDRESS)",
          value: "address_2",
          checked: false
        },
        {
          label: "UAN NO.",
          value: "uan_number",
          checked: false
        },
        {
          label: "PF RELATIONSHIP",
          value: "pf_relationship",
          checked: false
        },
        {
          label: "IS METRO",
          value: "is_metro",
          checked: false
        },
        {
          label: "CITY",
          value: "city",
          checked: false
        },
        {
          label: "STATE",
          value: "state",
          checked: false
        },
        {
          label: "COUNTRY",
          value: "country",
          checked: false
        },
        {
          label: "PIN",
          value: "pin",
          checked: false
        },
        {
          label: "MOBILE NO.",
          value: "mobile_number",
          checked: false
        },
        {
          label: "PERSONAL EMAIL ID",
          value: "personal_email_id",
          checked: false
        },
        {
          label: "BLOOD GROUP",
          value: "blood_group",
          checked: false
        },
        {
          label: "UDF FIELDS",
          value: "udf",
          checked: false
        },
        {
          label: "PRAN Number",
          value: "pran_number",
          checked: false
        },
      ],
      showLoader: false,
      employeeCount: 0
    };

  },
  watch: {
    subreptype(val) {
      try {
        this.employeeData = [];
        switch (this.subreptype) {
          case "Claims": {
            this.statusLabel = "Claims Status";
            this.statusOptions = ["Approved", "Partially Approved", "Rejected"];
            break;
          }
          case "Declaration Report": {
            this.statusLabel = "Declaration Status";
            this.statusOptions = ["Declared", "Not Declared"];
            break;
          }
          case "Investment Proof": {
            this.statusLabel = "Investment Proof Status";
            this.statusOptions = ["Submitted", "Approved", "Disapproved"];
            break;
          }
          case "FBP Payout": {
            this.statusLabel = "FBP Payout Status";
            this.statusOptions = ["Monthly", "For Employee", "Overall"];
            break;
          }
          case "Statutory bonus": {
            this.statusLabel = "Statutory bonus Status";
            this.statusOptions = ["Monthly", "Yearly"];
            break;
          }
          case "Salary Register V2":{
            this.getAdditionalFieldsDataNew()
          }
          default:
            this.statusLabel = "";
            this.statusOptions = [];
            break;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    }
  },
  computed: {
    ...mapState("onboard/organization", {
      orgId: state => state.id
    }),
    ...mapState({
      entities: state => state.onboard.legal_entities.data
    }),
    subreptypeoption() {
      if (this.reptype == "Bank")
        return [
          "Bank Advice",
          "Bank Transfer",
          "Bank Summary",
          "Payroll Summary"
        ];
      if (this.reptype == "Payroll")
        return [
          "Salary Register",
          // "Salary Register V2"
          // "Journal Voucher",
          // "Variance",
          // "Employee Master",
          // "Head Count Reports",
          // "Demo Report",
        ];
      if (this.reptype == "Statutory")
        return [
          "PF",
          "ESI",
          "LWF",
          "PT",
          "IT"
        ];
        if (this.reptype == "IncomeTax")
        return [
          //"Form16",
          "IT Computation",
          // "IT Computation V2",
          //"IT Computation Demo Report"
        ];
        if (this.reptype == "Salary")
        return [
          // "Payslip",
          "Annual Salary Report"
        ];
        if (this.reptype == "Employee Exit Reports")
        // Old code is comment out
        // return [
        //   "Resigned", 
        //   "Fired", 
        //   "Retired", 
        //   "Notice Period",
        // ];
        // below is new code added
        return [
          "Absconding",
          "Death",
          "Termination",
          "Resigned",
          "Retirement/ Super Annutation"
        ]
      return [];
    },
    le_id() {
      return this.$store.getters["onboard/legal_entities/legal_entity_ID"](
        this.$route.params.entity_index
      );
    },
    ifTeamLeader() {
      return localStorage.getItem("userRole") == "TEAMLEADER" ? true : false;
    },
    ifAnchor() {
      return localStorage.getItem("userRole") == "ANCHOR" ? true : false;
    },
    ifHr() {
      return localStorage.getItem("userRole") == "HR" ? true : false;
    },
    ifEmployee() {
      return localStorage.getItem("userRole") == "EMPLOYEE" ? true : false;
    },
    ifTeamleaderAnchorPermission() {
      if(this.role === 'TEAMLEADER' || this.role === 'ANCHOR' || this.role === 'ADMIN') {
        if(this.reportosValue) {
          return true;
        } else {
          return false;
        }
      } 
      // else {
      //   return true 
      // }
    },
  },
  components: {
    twentyFourQReport,
    SearchDropdown,
    SelectedEmployeeCard
  },
  activated() {
    this.count();
    this.getPaygroups();
    this.generateFinancialYear();
    this.getAdditionalFieldsData();
    this.getOrgLeIdList();
    this.fetchEmployeeCount();
    this.reportDataTransfer();
  },
  mounted() {
    this.updateReportype();
    this.getOrgLeIdList();
    this.fetchEmployeeCount();
  },
  methods: {
    ...mapActions({
      downloadSR:
        "dashboard/payroll/reports/Reports/downloadSalaryRegisterReport",
      downloadSRtwo:"dashboard/payroll/reports/Reports/downloadSalaryRegisterReportTwo",
      downloadSRforEmpCodes:"dashboard/payroll/reports/Reports/downloadSalaryRegisterReportforSpecificEmpCodes",
      downloadSRtwoNew:"dashboard/payroll/reports/Reports/downloadSalaryRegisterReportTwoNew",
      downloadSRthree:"dashboard/payroll/reports/Reports/downloadSalaryRegisterReportThree",
      downloadBankSummary:
        "dashboard/payroll/reports/Reports/downloadBankSummaryReport",
      downloadPayrollSummary:
        "dashboard/payroll/reports/Reports/downloadPayrollSummaryReport",
      downloadCTC: "dashboard/payroll/reports/Reports/downloadSalaryCTCReport",
      downloadVariance:
        "dashboard/payroll/reports/Reports/downloadVarianceReport",
      downloadJV: "dashboard/payroll/reports/Reports/downloadJVReport",
      downloadITComputation: "dashboard/payroll/reports/Reports/downloadITComputationReport",
      processDownload:"dashboard/payroll/reports/Reports/processDownloadReport",
      downloadITComputationNew: "dashboard/payroll/reports/Reports/downloadITComputationReportNew",
      downloadHC: "dashboard/payroll/reports/Reports/downloadHCReport",
      downloadBA: "dashboard/payroll/reports/Reports/downloadBAReport",
      downloadBT: "dashboard/payroll/reports/Reports/downloadBTReport",
      downloadTDS: "dashboard/payroll/reports/Reports/downloadTDSReport", // PL_2410
      downloadLOP: "dashboard/payroll/reports/Reports/downloadLOPReport",
      downloadCustomSalaryReport: "dashboard/payroll/reports/Reports/downloadSalaryReport",
      downloadStatutory:
        "dashboard/payroll/reports/Reports/downloadStatutoryReports",
      fetchEmployees: "globalapi/globalemployees/fetchAll",
      fetchEmployeeByName: "globalapi/globalemployees/fetchByName",
      act_fetch: "dashboard/payroll/reports/Reports/fetchAll",
      fetch_paygroups: "onboard/paygroup/fetchAll",
      fetch_locations: "onboard/locations/fetchAll",
      fetch_grades: "onboard/salary_grades/fetchAll",
      fetch_bands: "onboard/salary_bands/fetchAll",
      fetch_departments: "onboard/departments/fetchAll",
      fetch_cost_center: "onboard/cost_centres/fetchAll",
      fetch_designation: "onboard/designations/fetchAll",
      downloadForm16Reports:"dashboard/payroll/reports/Reports/downloadform16Report",
      downloadpayslip:
        "dashboard/organisation/utilities/itsheetandpayslip/downloadPayslip",
      downloadEmployeeReport:
        "dashboard/payroll/reports/Reports/downloadEmployeeReports",
      fetchEmployeeByLeAndName: "globalapi/globalemployees/fetchByLeAndName",
      downloadAnnualSalaryReports: "dashboard/payroll/reports/Reports/downloadAnnualSalaryReport",
      getAdditionalFields: "dashboard/payroll/reports/Reports/getAdditionalFieldsData",
      getAdditionalFieldsNew: "dashboard/payroll/reports/Reports/getAdditionalFieldsDataNew",
      getSalaryRegisterPattern: "dashboard/payroll/reports/Reports/getSalaryRegisterPattern",
      fetch_Employee:"onboard/employees/fetchAll",
      downloadITComputationV2: "dashboard/payroll/reports/Reports/downloadITComputationV2Report",
      act_download_report_data_transfer: "dashboard/payroll/newReports/reportDataTransfer",
      act_check_payroll_completion : "dashboard/payroll/newReports/checkPayrollCompletedToEnableReportDownload",
    }),


   /* function to count the employees based on the length of list */
    count() {
      try {
        if (this.$route.params.selemplist) {
          this.empcount = this.$route.params.selemplist.length;
        } else {
          this.empcount = this.employeeData.length;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    
    async downloadITComputationV2Report() {
      try {
        if (this.financialYear.value && this.month) {
          let obj = {
            le_id: this.le_id,
            month: this.month.value,
            year: this.financialYear.value,
            status: 'both'
          };
          this.toast = false;
          this.showLoader = true;
          let res = await this.downloadITComputationV2(obj);
          this.showLoader = false;
          this.toast = false;
        } else {
          this.toast = true;
          this.errmsg = "Please select financial year and month";
        }
      } catch (error) {
        setTimeout(() => {
          this.toast = true;
          this.showLoader = false;
          this.errmsg = error;
        }, 1000);
      }
    },

    async reportDataTransfer(){
      try {
          let obj ={
              le_id : this.le_id,
          }
          await this.act_download_report_data_transfer(obj);
      } catch (error) {
          this.toast = true;
          this.errmsg = error;
      }
    },
    /* function to generate financial year from previous 5 years */
    generateFinancialYear() {
      try {
        let date = new Date();
        let year =
          date.getMonth() > 2 ? date.getFullYear() : date.getFullYear() - 1;
        for (let i = year; i > year - 5; i--) {
          this.financialYearList.push({
            name: i + "-" + (i + 1),
            value: i + ""
          });
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    updateFinancialYear(val) {
      if (val.index < 3) {
        this.financialYear.value = this.financialYear.name.split("-")[1];
      } else {
        this.financialYear.value = this.financialYear.name.split("-")[0];
      }
    },
    backUpload(){
      this.showSuccessBulkUploadMsg = false
      this.showSuccessDownload = false
    },

    /* function to get months of a financial year based on selected financial year */
    getFinancialYearMonths() {
      try {
        let date = new Date();
        if (
          date.getMonth() > 2 &&
          this.financialYear.value == date.getFullYear()
        ) {
          let index = this.monthsList.findIndex(
            item => item.name == this.monthArray[date.getMonth()]
          );
          this.monthOptions = this.monthsList.slice(0, index + 1);
        } else if (this.financialYear.value < date.getFullYear() - 1) {
          this.monthOptions = this.monthsList;
        } else if (this.financialYear.value == date.getFullYear() - 1) {
          if (date.getMonth() < 3) {
            let index = this.monthsList.findIndex(
              item => item.name == this.monthArray[date.getMonth()]
            );
            this.monthOptions = this.monthsList.slice(0, index + 1);
          } else {
            this.monthOptions = this.monthsList;
          }
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    async getAdditionalFieldsDataNew(){
      try {
        let obj = {
          le_id: this.le_id
        }
        let result = await this.getAdditionalFieldsNew(obj)
        let pattern = await this.getSalaryRegisterPattern (obj)
        console.log("whhebghbuihsuihui",pattern)
        this.employeeInfoList.concat(this.employeeInfoListOfficial)
        this.employeeInfoList.forEach(item => {
              item.checked = false;
             });
        for(let i in result.data.payload.additional_fields){
           this.employeeInfoList.push({
            label:result.data.payload.additional_fields[i],
            value:result.data.payload.additional_fields[i].toLowerCase(),
            checked:false
           })
        }
        this.employeeInfoList.find(field => field.value === "code").checked = true;
        this.employeeInfoList.find(field => field.value === "name").checked = true;
        let newEmployeeInfoList = this.employeeInfoList.filter((element,index,array)=>
              
                index === array.findIndex((t)=>
                t.label === element.label
              )
         )
         if(pattern&&pattern.data&&pattern.data.data[0].pattern){
          newEmployeeInfoList.forEach((ele)=>{
              ele.checked = pattern&&pattern.data&&pattern.data.data[0].pattern.includes(ele.value)
          })
         }
         newEmployeeInfoList.find(field => field.value === "code").checked = true;
         newEmployeeInfoList.find(field => field.value === "name").checked = true;
         this.employeeInfoList = newEmployeeInfoList
        const checkedItemsEmployeeInfoList = this.employeeInfoList.filter(field => field.checked);
        this.checkedArray = checkedItemsEmployeeInfoList;
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    async getAdditionalFieldsData(){
      try {
        let obj = {
          le_id: this.le_id
        }
        let res = await this.getAdditionalFields(obj)
        let existingAdditionalFields =  res.data.payload.additional_fields;

        if(existingAdditionalFields){
        this.employeeInfoListOfficial.forEach(field => {
          field.checked = existingAdditionalFields.includes(field.value);
        });
        this.employeeInfoList.forEach(field => {
          field.checked = existingAdditionalFields.includes(field.value);
        });
        console.log("employeeInfoList",this.employeeInfoList);
        this.employeeInfoList.find(field => field.label === "CODE").checked = true;
        this.employeeInfoList.find(field => field.label === "NAME").checked = true;

        // Filter out items with checked: true from employeeInfoList
        const checkedItemsEmployeeInfoList = this.employeeInfoList.filter(field => field.checked);
        const checkedItemsEmployeeInfoListOfficial = this.employeeInfoListOfficial.filter(field => field.checked);
        this.checkedArray = checkedItemsEmployeeInfoList.concat(checkedItemsEmployeeInfoListOfficial);
        // this.selectTitle = "Unselect All"
        // this.checkedArray = checkedItemsEmployeeInfoList;
      //   let existingAdditionalFields =  res.data.payload.additional_fields;
      //   if(existingAdditionalFields){
      //   this.employeeInfoListOfficial.forEach(field => {
      //     field.checked = existingAdditionalFields.includes(field.value);
      //   });
      //   // this.employeeInfoList.forEach(field => {
      //   //   field.checked = existingAdditionalFields.includes(field.value);
      //   // });
      //   // this.employeeInfoList.find(field => field.label === "Code").checked = true;
      //   // this.employeeInfoList.find(field => field.label === "Name").checked = true;

      //   // // Filter out items with checked: true from employeeInfoList
      //   // const checkedItemsEmployeeInfoList = this.employeeInfoList.filter(field => field.checked);
      //   // // Filter out items with checked: true from employeeInfoListOfficial
      //   // const checkedItemsEmployeeInfoListOfficial = this.employeeInfoListOfficial.filter(field => field.checked);

      //   // Combine items with checked: true from both arrays
      //   // this.checkedArray = checkedItemsEmployeeInfoList.concat(checkedItemsEmployeeInfoListOfficial);
       }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    /* server call to get employees based on selected filter optons */
    async applyFilter() {
      try {
        let obj = {
          le_id: this.le_id,
          month: this.month.value,
          financial_year: this.financialYear.value,
          bands:
            this.criteria == "Band"
              ? this.subcriteria.map(item => {
                  return item.id;
                })
              : [],
          bunits:
            this.criteria == "Business Unit"
              ? this.subcriteria.map(item => {
                  return item.id;
                })
              : [],
          cost_centers:
            this.criteria == "Cost Centre"
              ? this.subcriteria.map(item => {
                  return item.id;
                })
              : [],
          locs:
            this.criteria == "Location"
              ? this.subcriteria.map(item => {
                  return item.id;
                })
              : [],
          paygroups: this.paygroup.length
            ? this.paygroup.map(item => {
                return item.id;
              })
            : []
        };
        let res = await this.act_fetch({ obj: obj, page: 1 });
        if (res.data.status) {
          this.employeeData = res.data.payload.data;
          this.empcount = res.data.payload.totalEmpCount;
               // PL_3064
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* function to get subcriteria after selecting criteria */
    onSelectCriteria(event) {
      try {
        this.subcriteria = [];
        if (event == "Location") {
          this.subCriteriaLabel = "Location";
          this.getLocations();
        } else if (event == "Cost Centre") {
          this.subCriteriaLabel = "Cost Centre";
          this.getCostCenter();
        } else if (event == "Band") {
          this.subCriteriaLabel = "Band";
          this.getBands();
        } else if (event == "Grade") {
          this.subCriteriaLabel = "Grade";
          this.getGrades();
        } else if (event == "Department") {
          this.subCriteriaLabel = "Department";
          this.getDepartments();
        } else {
          this.subCriteriaLabel = "Sub Criteria";
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* server call to get locations for the current legal entity */
    async getLocations() {
      try {
        let res = await this.fetch_locations(this.le_id);
        if (res.data.status) {
          this.subCriteriaList = res.data.payload.data;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* server call to get salary bands for the current legal entity */
    async getBands() {
      try {
        let res = await this.fetch_bands(this.le_id);
        if (res.data.status) {
          this.subCriteriaList = res.data.payload.data;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* server call to get paygroups for the current legal entity */
    async getPaygroups() {
      try {
        let res = await this.fetch_paygroups(this.le_id);
        if (res.data.status) {
          this.paygroupOptions = res.data.payload.data;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* server call to get business units for the current organisation */
    async getDepartments() {
      try {
        let res = await this.fetch_departments(this.le_id);
        if (res.data.status) {
          this.subCriteriaList = res.data.payload.data;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* server call to get cost centres for the current legal entity */
    async getCostCenter() {
      try {
        let res = await this.fetch_cost_center(this.le_id);
        if (res.data.status) {
          this.subCriteriaList = res.data.payload.data;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* server call to get salary grades for the current legal entity */
    async getGrades() {
      try {
        let res = await this.fetch_grades(this.le_id);
        if (res.data.status) {
          this.subCriteriaList = res.data.payload.data;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    async ProcessDownloadReport(){

      try {
       if (this.subreptype == "Salary Register") {
        let obj = {
                le_id: this.le_id,
                month: this.month.value,
                financialYear: this.financialYear.value,
                total_employees: this.employeeCount,
                legal_entity_name: this.entities[0]['legalName'],
                bands:
                  this.criteria == "Band"
                    ? this.subcriteria.map(item => {
                        return item.id;
                      })
                    : [],
                bunits:
                  this.criteria == "Business Unit"
                    ? this.subcriteria.map(item => {
                        return item.id;
                      })
                    : [],
                cost_centers:
                  this.criteria == "Cost Centre"
                    ? this.subcriteria.map(item => {
                        return item.id;
                      })
                    : [],
                locs:
                  this.criteria == "Location"
                    ? this.subcriteria.map(item => {
                        return item.id;
                      })
                    : [],
                paygroups: this.paygroup.length
                  ? this.paygroup.map(item => {
                      return item.id;
                    })
                  : [],
                page: 1, 
              };
        if (this.subreptype == "Salary Register") {
          console.log(this.subreptype, "Inside Process")
    
          if (this.financialYear.value && this.month) {
            /* PL_3064 */
            this.showLoader = true;
            let res = await this.downloadSRthree({
              data: obj, addtionalFields : this.additionalFieldsArrayTwo,   
            });
            this.showLoader = false;
            // this.showSuccessBulkUploadMsg = true;
            this.toast = false;
          } else {
            this.toast = true;
            this.errmsg = "Please select financial year and month";
          }
        }
       }
       else if(this.subreptype == "IT Computation V2"){
            this.downloadITComputationV2Report();
        }
       else{
        let obj={
                le_id: this.le_id,
                month: this.month.value,
                financialYear: this.financialYear.value,
                total_employees: this.employeeCount,
                legal_entity_name: this.entities[0]['legalName'],
                }
          this.toast = false;
          this.showLoader = true;
          let res = await this.processDownload(obj);
          this.showLoader = false;
          this.showSuccessDownload = true;
          this.toast = false;
      } 
    }catch (error) {
      this.showLoader = false;
      this.toast = true;
      this.errmsg = error
      }
    },

    /* server call to download reports of various types */
    async downloadReport() {
      try {
        this.additionalFieldsArray=[],
        this.additionalFieldsArrayTwo=[],
        this.additionalFieldsObj= {},
        this.additionalField()
        let value = this.details.split(",");
        let value2 = [];
        value.map(element => {
          if(element){
            value2.push(element.trim());
          }
        })
        let filter = value2.filter(element => element !== "")
        let object = {
          data: filter,
        }
        let codes = object.data
        let obj = {
                le_id: this.le_id,
                month: this.month.value,
                financialYear: this.financialYear.value,
                total_employees: this.employeeCount,
                legal_entity_name: this.entities[0]['legalName'],
                bands:
                  this.criteria == "Band"
                    ? this.subcriteria.map(item => {
                        return item.id;
                      })
                    : [],
                bunits:
                  this.criteria == "Business Unit"
                    ? this.subcriteria.map(item => {
                        return item.id;
                      })
                    : [],
                cost_centers:
                  this.criteria == "Cost Centre"
                    ? this.subcriteria.map(item => {
                        return item.id;
                      })
                    : [],
                locs:
                  this.criteria == "Location"
                    ? this.subcriteria.map(item => {
                        return item.id;
                      })
                    : [],
                paygroups: this.paygroup.length
                  ? this.paygroup.map(item => {
                      return item.id;
                    })
                  : [],
                page: 1, 
              };

        if (this.subreptype == "Demo Report") {
          // if (
          //   this.$route.params.selemplist &&
          //   this.$route.params.selemplist.length
          // ) {
          //   this.employeeData = this.$route.params.selemplist;
          // }
           
          if (this.financialYear.value && this.month) {
            /* PL_3064 */
            this.showLoader = true;
            let res = await this.downloadSR({
              data: obj, addtionalFields : this.additionalFieldsArray,   
            });
            this.showLoader = false;
            // this.showSuccessBulkUploadMsg = true;
            this.toast = false;
          } else {
            this.toast = true;
            this.errmsg = "Please select financial year and month";
          }
        }
        // if (this.subreptype == "Salary Register") {
              
        //   if (this.financialYear.value && this.month) {
        //     /* PL_3064 */
        //     this.showLoader = true;
        //     let res = await this.downloadSRtwo({
        //       data: obj, addtionalFields : this.additionalFieldsArrayTwo,   
        //     });
        //     console.log("resposmne in download",res);
            
        //     this.showLoader = false;
        //     // this.showSuccessBulkUploadMsg = true;
        //     this.toast = false;
        //   } else {
        //     this.toast = true;
        //     this.errmsg = "Please select financial year and month";
        //   }
        // }
         // if (this.subreptype == "Salary Register") {
              
        //  if (this.financialYear.value && this.month) {
        //     /* PL_3064 */
        //     this.showLoader = true;
        //     let res = await this.downloadSRtwo({
        //       data: obj, addtionalFields : this.additionalFieldsArrayTwo,   
        //     });
        //     this.showLoader = false;
        //     // this.showSuccessBulkUploadMsg = true;
        //     this.toast = false;
        //   } else {
        //     this.toast = true;
        //     this.errmsg = "Please select financial year and month";
        //   if (this.financialYear.value && this.month) {
        //     /* PL_3064 */
        //     this.showLoader = true;
        //     let res = await this.downloadSRtwo({
        //       data: obj, addtionalFields : this.additionalFieldsArrayTwo,   
        //     });
        //     console.log("resposmne in download",res);
            
        //     this.showLoader = false;
        //     // this.showSuccessBulkUploadMsg = true;
        //     this.toast = false;
        //   } else {
        //     this.toast = true;
        //     this.errmsg = "Please select financial year and month";
        //   }
        // }
         if(this.subreptype == "Salary Register V2" ){
          if (this.details == '') {
            if (this.financialYear.value && this.month) {
            /* PL_3064 */
            this.showLoader = true;
            let obj ={
              le_id: this.le_id,
                month: this.month.value,
                financialYear: this.financialYear.value,
                status :"both",
                additional_fields : this.additionalFieldsArrayTwo,
            }
            // let res = await this.downloadSRtwo({
            //   data: obj, addtionalFields : this.additionalFieldsArrayTwo,   
            // });
            let result = await this.downloadSRtwoNew(
              obj
            )
            this.showLoader = false;
            // this.showSuccessBulkUploadMsg = true;
            this.toast = false;
          } else {
            this.toast = true;
            this.errmsg = "Please select financial year and month";
          }
          }
          else {
            if (this.financialYear.value && this.month) {
              this.showLoader = true;
              let res = await this.downloadSRforEmpCodes({
                data: obj, addtionalFields: this.additionalFieldsArrayTwo, employeeCodes: codes
              });
              this.showLoader = false;
              // this.showSuccessBulkUploadMsg = true;
              this.toast = false;
            } else {
              this.toast = true;
              this.errmsg = "Please select financial year and month";
            }
          
        }
         }
        if (this.subreptype == "Salary Register") {
          if (this.details == '') {
            if (this.financialYear.value && this.month) {
            /* PL_3064 */
            this.showLoader = true;
            let res = await this.downloadSRtwo({
              data: obj, addtionalFields : this.additionalFieldsArrayTwo,   
            });
          
            this.showLoader = false;
            this.showSuccessBulkUploadMsg = true;
            this.toast = false;
          } else {
            this.toast = true;
            this.errmsg = "Please select financial year and month";
          }
          }
          else {
            if (this.financialYear.value && this.month) {
              this.showLoader = true;
              let res = await this.downloadSRforEmpCodes({
                data: obj, addtionalFields: this.additionalFieldsArrayTwo, employeeCodes: codes
              });
              this.showLoader = false;
              this.showSuccessBulkUploadMsg = true;
              this.toast = false;
            } else {
              this.toast = true;
              this.errmsg = "Please select financial year and month";
            }
          
        }}
        if (this.subreptype == "CTC Reconciliation") {
          // let selectedEMployeesList = [];
          // if (this.$route.params.selemplist) {
          //   selectedEMployeesList = this.$route.params.selemplist;
          // } else {
          //   selectedEMployeesList = this.employeeData;
          // }
          this.showLoader = true;
          let res = await this.downloadCTC({
            data: obj
          });
          this.showLoader = false;
        }

        if (this.subreptype == "LOP Report") {
          this.downloadlop(obj);
        }
        if (this.subreptype == "Employee Master") {
            if (this.financialYear.value && this.month) {
            this.downloadSalaryReport(obj);
          } else {
            this.toast = true;
            this.errmsg = "Please select financial year and month";
          }
          
        }
        if (this.subreptype == "Journal Voucher") {
          this.downloadJVReports(obj);
        }
        if (this.subreptype == "Variance") {
          this.downloadVarianceReports(obj);
        }
        if (this.subreptype == "Head Count Reports") {
          this.downloadHCReports(obj);
        }
        if (this.subreptype == "Bank Advice") {
          this.downloadBAReports(obj);
        }
        if (this.subreptype == "Bank Transfer") {
          this.downloadBTReports(obj);
        }
        if (this.subreptype == "Bank Summary") {
          this.downloadBankSummaryReports(obj);
        }
        if (this.subreptype == "Payroll Summary") {
          this.downloadPayrollSummaryReports(obj);
        }
        // PL_2410
        if (this.subreptype == "TDS Report") {
          this.downloadTDSReports(obj);
        }
        if (this.subreptype == "PF") {
          this.downloadStatutoryReports(obj, "pf_report");
        }
        if (this.subreptype == "ESI") {
          this.downloadStatutoryReports(obj, "esi_report");
        }
        if (this.subreptype == "LWF") {
          this.downloadStatutoryReports(obj, "lwf_report");
        }
        if (this.subreptype == "PT") {
          this.downloadStatutoryReports(obj, "pt_report");
        }
        if(this.subreptype =="Form16"){
          this.downloadForm16Report();
        }
        if(this.subreptype == "IT Computation"){
                    this.downloadITComputationReport();
        }
        if(this.subreptype == "IT Computation Demo Report"){
          this.downloadITComputationReportNew();
        }
        if(this.subreptype =="Payslip"){
          this.downloadPayslip();
        }
        if (this.subreptype == "Resigned") {
          this.empStatus = "Resigned"
          this.downloadEmployeeReports(this.empStatus);
        }
        if (this.subreptype == "Fired") {
          this.empStatus = "fired"
          this.downloadEmployeeReports(this.empStatus);
        }
        if (this.subreptype == "Retired") {
          this.empStatus = "retired"
          this.downloadEmployeeReports(this.empStatus);
        }
        if (this.subreptype == "Notice Period") {
          this.empStatus = "notice_period"
          this.downloadEmployeeReports(this.empStatus);
        }
        if (this.subreptype == "Absconding") {
          this.empStatus = "Absconding"
          this.downloadEmployeeReports(this.empStatus);
        }
        if (this.subreptype == "Death") {
          this.empStatus = "Death"
          this.downloadEmployeeReports(this.empStatus);
        }
        if (this.subreptype == "Termination") {
          this.empStatus = "Termination"
          this.downloadEmployeeReports(this.empStatus);
        }
        if (this.subreptype == "Retirement/ Super Annutation") {
          this.empStatus = "Retirement/ Super Annutation"
          this.downloadEmployeeReports(this.empStatus);
        }
        if(this.subreptype =="Annual Salary Report"){
          this.downloadAnnualSalaryReport();
        }
        this.checkPayroll()
    }
    catch (error) {
        setTimeout(() => {
          this.toast = true;
          this.showLoader = false;
          this.errmsg = error;
        }, 1000);
      }},
     /* server call to download the payslip of an employee */
    async downloadPayslip() {
      try {
        let bodyParams = {};
        let  data = await this.getOrgLeList({
          data: {
              ...bodyParams
          }
        });
        this.employee_id = data.data.user.employee_id;
        this.showLoader = true;
        let res = await this.downloadpayslip({
          le_id: this.le_id,
          empId: this.employee_id, // PL_3042
          org_id: this.orgId,
          paygroup_id:this.paygroupOptions[0].id, // PL_3042
          financialYear: this.financialYear.value,
          month:this.month.value // PL_3042
        });
        this.showLoader = false;
      } catch (error) {
        //console.log("this is error log",error);
        setTimeout(() => {
          this.toast = true;
          this.showLoader = false;
          this.errmsg = error;
        }, 1000);
      }
    },

        /* server call to download JV reports */
    async downloadForm16Report() {
      try {
        let bodyParams = {};
        let  data = await this.getOrgLeList({
          data: {
              ...bodyParams
          }
        });
        this.employee_id = data.data.user.employee_id;
        this.instance = {
          empId:this.employee_id,
          financialYear:this.financialYear.name,
          page:'1'
        }
        this.showLoader = true;
        let res= await this.downloadForm16Reports(this.instance);
        this.showLoader = false;
      } catch (error) {
        setTimeout(() => {
          this.toast = true;
          this.showLoader = false;
          this.errmsg = error;
        }, 1000);
      }
    },

    /* server call to download JV reports */
    async downloadJVReports(obj) {
      try {
        // if (
        //   this.$route.params.selemplist &&
        //   this.$route.params.selemplist.length
        // ) {
        //   this.employeeData = this.$route.params.selemplist;
        // }
        if (this.financialYear.value && this.month) {
          this.toast = false;
          this.showLoader = true;
          let res = await this.downloadJV({
            data: obj
          });
          this.showLoader = false;
          this.toast = false;
        } else {
          this.toast = true;
          this.errmsg = "Please select financial year and month";
        }
      } catch (error) {
        setTimeout(() => {
          this.toast = true;
          this.showLoader = false;
          this.errmsg = error;
        }, 1000);
      }
    },

    /* server call to download IT Computation reports */
    async downloadITComputationReport() {
      try {
        if (this.financialYear.value && this.month) {
          let obj = {
              le_id: this.le_id,
              month: this.month.value,
              financialYear: this.financialYear.value,
              total_employees: this.employeeCount,
              legal_entity_name: this.entities[0]['legalName'],
          };

          this.toast = false;
          this.showLoader = true;
          let res = await this.downloadITComputation(obj);
          this.showLoader = false;
          this.showSuccessBulkUploadMsg = true;
          this.toast = false;
        } else {
          this.toast = true;
          this.errmsg = "Please select financial year and month";
        }
      } catch (error) {
        setTimeout(() => {
          this.toast = true;
          this.showLoader = false;
          this.errmsg = error;
        }, 1000);
      }
    },

    async downloadITComputationReportNew() {
      try {
        if (this.financialYear.value && this.month) {
          let obj = {
              le_id: this.le_id,
              month: this.month.value,
              financialYear: this.financialYear.value
          };

          this.toast = false;
          this.showLoader = true;
          let res = await this.downloadITComputationNew(obj);
          this.showLoader = false;
          this.toast = false;
        } else {
          this.toast = true;
          this.errmsg = "Please select financial year and month";
        }
      } catch (error) {
        setTimeout(() => {
          this.toast = true;
          this.showLoader = false;
          this.errmsg = error;
        }, 1000);
      }
    },
  
    selectAll(flag) {
      this.checkedArray = []
      this.employeeInfoList.forEach(element => {
        if (flag) {
          if (element.value !== "name" && element.value !== "code")
          {
          this.checkedArray.push(element)
          }
          return element.checked = flag;
        } else {
          if (element.value !== "name" && element.value !== "code") {
            return element.checked = flag;
          }
        }
      });
       this.employeeInfoListOfficial.forEach(element => {
        if (flag) {
          this.checkedArray.push(element)
          return element.checked = flag;
        } else {
          if (element.value !== "name" && element.value !== "code") {
            return element.checked = flag;
          }
        }
      });
      this.selectTitle = flag ? 'Unselect All' : 'Select All'
    },

    select(type, item){
      if(item.value!=="name" && item.value!=="code"){
        if(!type){
        item.checked = !item.checked;
        this.checkedArray.push(item);
        //console.log(this.checkedArray)
        } else{
        item.checked = !item.checked;
        this.checkedArray = this.checkedArray.filter(el => {
          if(el.value !== item.value){
            return el;
          }
        })
        }
      }
    },
    
    additionalField() {
      if(this.subreptype == "Employee Master") {
      this.checkedArray.map((element)=>{
       this.additionalFieldsObj[element.value]=true
       })
      }
      else if(this.subreptype == "Demo Report") {
      this.checkedArray.map((elements)=>{
        this.additionalFieldsArray.push(elements.value)
       })
      }
      else if(this.subreptype == "Salary Register V2") {
         if(this.checkedArray.length > 2){
          this.checkedArray.map((elements)=>{
          if (elements.value !== "code" && elements.value !== "name") {
          this.additionalFieldsArrayTwo.push(elements.value);
       }
        })
         }
         if(this.checkedArray.length == 2){
          this.employeeInfoList.map((elements)=>{
          if (elements.value !== "code" && elements.value !== "name") {
          this.additionalFieldsArrayTwo.push(elements.value);
      }
        })
         }
      }
      else if(this.subreptype == "Salary Register") {
         if(this.checkedArray.length > 2){
          this.checkedArray.map((elements)=>{
          if (elements.value !== "code" && elements.value !== "name") {
          this.additionalFieldsArrayTwo.push(elements.value);
}
        })
         }
         if(this.checkedArray.length == 2){
          this.employeeInfoList.map((elements)=>{
          if (elements.value !== "code" && elements.value !== "name") {
          this.additionalFieldsArrayTwo.push(elements.value);
}
        })
         }
      }
    },
   
    removeTag(type, item){
      if(item.value!=="name" && item.value!=="code"){
        item.checked = !item.checked;
        this.checkedArray = this.checkedArray.filter(el => {
          if(el.value !== item.value){
            return el;
          }
        })
      }
    },

    /* server call to download Variance reports */
    async downloadVarianceReports(obj) {
      try {
        // if (
        //   this.$route.params.selemplist &&
        //   this.$route.params.selemplist.length
        // ) {
        //   this.employeeData = this.$route.params.selemplist;
        // }
        if (this.financialYear.value && this.month) {
          let previousMonth = "";
          let previousYear = "";
          if (this.month.name == "January") {
            previousMonth = "December";
            previousYear = Number(this.financialYear.value) - 1 + "";
          } else {
            previousYear = this.financialYear.value;
            previousMonth = this.monthsList[
              this.monthsList.findIndex(item => item.name == this.month.name) -
                1
            ];
          }
          this.showLoader = true;
          let res = await this.downloadVariance({
            data: {
              ...obj,
              preFinancialYear: previousYear,
              preMonth: previousMonth

            }
          });
          this.showLoader = false;
          this.toast = false;
        } else {
          this.toast = true;
          this.errmsg = "Please select financial year and month";
        }
      } catch (error) {
        setTimeout(() => {
          this.toast = true;
          this.showLoader = false;
          this.errmsg = error;
        }, 1000);
      }
    },

    /* server call to download HeadCount reports */
    async downloadHCReports(obj) {
      try {
        if (this.financialYear.value && this.month) {
          this.showLoader = true;
          let res = await this.downloadHC({
            data: obj
          });
          this.showLoader = false;
          this.toast = false;
        } else {
          this.toast = true;
          this.errmsg = "Please select financial year and month";
        }
      } catch (error) {
        setTimeout(() => {
          this.toast = true;
          this.showLoader = false;
          this.errmsg = error;
        }, 1000);
      }
    },

    /* server call to download TDS reports */
    //  Start PL_2410
    async downloadTDSReports(obj) {
      try {
        // if (
        //   this.$route.params.selemplist &&
        //   this.$route.params.selemplist.length
        // ) {
        //   this.employeeData = this.$route.params.selemplist;
        // }
        if (this.financialYear.value && this.month) {
          this.showLoader = true;
          let res = await this.downloadTDS({
            data: obj
          });
          this.showLoader = false;
          this.toast = false;
        } else {
          this.toast = true;
          this.errmsg = "Please select financial year and month";
        }
      } catch (error) {
        setTimeout(() => {
          this.toast = true;
          this.showLoader = false;
          this.errmsg = error;
        }, 1000);
      }
    },

    /* server call to download Salary Bank Advise reports */
    //  End PL_2410
    async downloadBAReports(obj) {
      try {
        // if (
        //   this.$route.params.selemplist &&
        //   this.$route.params.selemplist.length
        // ) {
        //   this.employeeData = this.$route.params.selemplist;
        // }
        if (this.financialYear.value && this.month) {
          this.showLoader = true;
          let res = await this.downloadBA({
            data: obj
          });
          this.showLoader = false;
          this.toast = false;
        } else {
          this.toast = true;
          this.errmsg = "Please select financial year and month";
        }
      } catch (error) {
        setTimeout(() => {
          this.toast = true;
          this.showLoader = false;
          this.errmsg = error;
        }, 1000);
      }
    },

    async downloadBankSummaryReports(obj) {
      try {
        if (this.financialYear.value && this.month) {
          this.showLoader = true;
          let res = await this.downloadBankSummary({
            data: obj
          });
          this.showLoader = false;
          this.toast = false;
        } else {
          this.toast = true;
          this.errmsg = "Please select financial year and month";
        }
      } catch (error) {
        setTimeout(() => {
          this.toast = true;
          this.showLoader = false;
          this.errmsg = error;
        }, 1000);
      }
    },

    async downloadPayrollSummaryReports(obj) {
      try {
        if (this.financialYear.value && this.month) {
          this.showLoader = true;
          let res = await this.downloadPayrollSummary({
            data: obj
          });
          this.showLoader = false;
          this.toast = false;
        } else {
          this.toast = true;
          this.errmsg = "Please select financial year and month";
        }
      } catch (error) {
        setTimeout(() => {
          this.toast = true;
          this.showLoader = false;
          this.errmsg = error;
        }, 1000);
      }
    },

    /* server call to download Statutory reports */
    async downloadStatutoryReports(obj, reportType) {
      try {
        // if (
        //   this.$route.params.selemplist &&
        //   this.$route.params.selemplist.length
        // ) {
        //   this.employeeData = this.$route.params.selemplist;
        // }
        if (this.financialYear.value && this.month) {
          this.showLoader = true;
          let res = await this.downloadStatutory({
            data: {
              ...obj,
              report: reportType,
            }
          });
          this.showLoader = false;
          this.toast = false;
        } else {
          this.toast = true;
          this.errmsg = "Please select financial year and month";
        }
      } catch (error) {
        setTimeout(() => {
          this.toast = true;
          this.showLoader = false;
          this.errmsg = error;
        }, 1000);
      }
    },

    /* server call to download Bank Advise Transfer reports */
    async downloadBTReports(obj) {
      try {
        // if (
        //   this.$route.params.selemplist &&
        //   this.$route.params.selemplist.length
        // ) {
        //   this.employeeData = this.$route.params.selemplist;
        // }
        if (this.financialYear.value && this.month) {
          this.showLoader = true;
          let res = await this.downloadBT({
            data: obj
          });
          this.showLoader = false;
          this.toast = false;
        } else {
          this.toast = true;
          this.errmsg = "Please select financial year and month";
        }
      } catch (error) {
        setTimeout(() => {
          this.toast = true;
          this.showLoader = false;
          this.errmsg = error;
        }, 1000);
      }
    },

    async downloadSalaryReport(obj) {
      try {
        obj = { ...obj,
        "reportFields":{
           "employer_contribution_after_gross": true,
           "employer_contribution_after_net": false,
           "unpaid_ctc_component_after_gross": true,
           "unpaid_ctc_component_after_net": false,
           "column_with_zero": true
       },
       "additionalFields":this.additionalFieldsObj
       }
        this.showLoader = true;
        let res = await this.downloadCustomSalaryReport({ data: obj });
        this.showLoader = false;
      } catch (error) {
        setTimeout(() => {
          this.toast = true;
          this.showLoader = false;
          this.errmsg = error;
        }, 1000);
      }
    },

    /* server call to download LOP reports */
    async downloadlop(obj) {
      // try {
      //   if (this.$route.params.selemplist) {
      //     this.preparereq(this.$route.params.selemplist);
      //   } else {
      //     this.preparereq(this.employeeData);
      //   }
      // } catch (error) {
      //   this.toast = true;
      //   this.errmsg = error;
      // }
      try {
        this.showLoader = true;
        let res = await this.downloadLOP({ data: obj });
        this.showLoader = false;
      } catch (error) {
        setTimeout(() => {
          this.toast = true;
          this.showLoader = false;
          this.errmsg = error;
        }, 1000);
      }
    },
    async preparereq(emplist) {
      try {
        let employees = [];
        emplist.forEach(emp => {
          let obj = {};
          obj.emp_id = emp.id;
          obj.emp_name = emp.first_name;
          obj.emp_code = emp.code;
          obj.le_id = emp.legal_entity_id;
          employees.push(obj);
        });
        this.request = {
          employees: employees,
          month: this.month.name,
          financial_year: this.financialYear.value
        };
        // call store action
        let res = await this.downloadLOP({ data: this.request });
      } catch (err) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* function to go to create custom reports */
    customreport() {
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index?this.$route.params.entity_index:"0"}/payroll/utilities/payrollReports`
      });
    },

    /* function to go to employees list to select */
    // currently not being used
    gotoEmployees() {
      try {
        if (this.subreptype != "Employee Master") {
          let selectedEMployeesList = [];
          if (this.$route.params.selemplist) {
            selectedEMployeesList = this.$route.params.selemplist;
          } else {
            selectedEMployeesList = this.employeeData;
          }
          this.$router.push({
            name: "dashboardSubstepname",
            params: {
              step_name: this.$route.params.step_name,
              sub_step: this.$route.params.sub_step,
              sub_step_name: "employees",
              entity_index: this.$route.params.entity_index,
              selectedEmpList: selectedEMployeesList,
              emplList: this.employeeData
            }
          });
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* function to reset other fields after changing report type*/
    async rpttypechanged(val) {
      try {
        this.reptype = val;
        this.subReportType = this.reptype == "Employee Exit Reports" ? "Employee Status" : "Sub-Report Type";
        this.subreptype = "";
        this.subCriteriaList = [];
        (this.subcriteria = []), (this.criteria = "");
        this.paygroup = [];
        this.subCriteriaLabel = "";
        let payload = {
          le_id :this.le_id,
          type: 'salary_register'
        }
        let res = await this.act_check_payroll_completion(payload)
        this.disableDownloadButton = res.data.payload
        // this.month = "";
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    async checkPayroll(){
      try{
        let payload = {
          le_id :this.le_id,
          type: 'salary_register'
        }
        let res = await this.act_check_payroll_completion(payload)
        this.disableDownloadButton = res.data.payload
      }catch(error){
        this.toast = true;
        this.errmsg = error;
      }
    },
    /* function is use for roles and rights to hide report type according to roles*/
    updateReportype() {
      if(this.ifHr || this.ifEmployee){
        this.reportType.splice(0,3);
        this.reportType.splice(2,1);
      }
    },

    ...mapActions({
        getOrgLeList: "onboard/organization/getOrgLeIdList",
    }),

    async getOrgLeIdList() {
      const org = this.orgId;
      const le = this.le_id;
      //console.log("Org:",org);
      //console.log("Le ID",le);
      let bodyParams = {};
      let  data = await this.getOrgLeList({
        data: {
            ...bodyParams
        }
      });
      this.role = data.data.user.userRole;
      this.reportosValue = data.data.user.permissions.reportos ? true : false;
      //console.log("PL-3406",data);
    },

    async fetchEmployeeCount() {
      let employeeData = await this.fetch_Employee({ le_id: this.le_id, page: 1 });
      this.employeeCount = employeeData.data.payload.total;
    },

    async downloadEmployeeReports(status) {
      try {
        if (this.financialYear.value && this.month) {
          let obj = {
              le_id: this.le_id,
              month: this.month.value,
              year: this.financialYear.value,
              status: status //this.subreptype.toLowerCase()
          };
          // let obj = {
          //     month: "Dec",
          //     le_id: "ee4c2d69-19e8-4e33-b0af-27d56548b39a",
          //     year: "2020",
          //     status: "resigned"
          // };
          this.toast = false;
          this.showLoader = true;
          let res = await this.downloadEmployeeReport(obj);
          this.showLoader = false;
          if(res == undefined) {
            this.showErrorPopup = true;
          }
          this.toast = false;
        } else {
          this.toast = true;
          this.errmsg = "Please select financial year and month";
        }
      } catch (error) {
        setTimeout(() => {
          this.toast = true;
          this.showLoader = false;
          this.errmsg = error;
        }, 1000);
      }
    },

    async searchEmployeesByName(val) {
      try {
        let res = await this.fetchEmployeeByLeAndName({
          le_id: this.le_id,
          key: val,
        });
        this.employeeList = res.data.payload;
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    
    async selectedEmp(emp) {
      try {
        this.datas = emp;
        this.showEmpDetails = true;
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    close() {
      this.showEmpDetails = false;
    },

    async downloadAnnualSalaryReport() {
      try {
        if (this.financialYear.value) {
          let obj = {
              code: this.datas.code,
              le_id: this.le_id,
              year: this.financialYear.value,
          }
      //{
      //   "code": "tsd04765",
      //   "le_id": "94ceb16c-e4d4-4fc5-8634-f2ab52593333",
      //   "year": "2020"
      // }
          this.toast = false;
          this.showLoader = true;
          let res = await this.downloadAnnualSalaryReports(obj);
          // if(res == undefined) {
          //   this.showErrorPopup = true;
          // }
          this.showLoader = false;
          this.toast = false;
        } else {
          this.toast = true;
          this.errmsg = "Please select financial year and month";
        }
      } catch (error) {
        setTimeout(() => {
          this.toast = true;
          this.showLoader = false;
          this.errmsg = error;
        }, 1000);
      }
    }
  }
};
</script>

<style lang="scss" scoped>

.fnfbtn {
  width: 200px;
  height: 50px;
  align-self: flex-start;
  background-color: #ffffff;
  border: #34c0be solid 1px;
  color: #34c0be;
  font-weight: bold;
  padding: 10px 10px;
  border-radius: 4px;
}

.width-480{
  width: 480px;
  height: 100px;
}

.head {
  margin-top: 37px;
}


.type {
  display: flex;
  margin-top: 30px;
  div {
    width: 250px;
    padding-right: 20px;
  }
}

.subtype {
  margin-top: 25px;
  margin-bottom: 25px;
}

.link {
  color: #5d409f;
  font-size: 12px;
  text-decoration: underline;
  padding-top: 10px;
  cursor: pointer;
}

.employeecard {
  margin-bottom: 20px;
  position: relative;
  border: solid 1px #f0f0f0;
  border-left: solid 10px;
  height: 65px;
  width: 205px;
  border-radius: 4px;
  padding-left: 13px;
  display: grid;
  align-items: center;
  font-size: 12px;
  background: #fbfbfb;
}

.d-pending {
  color: #34c0be;
  display: flex;
  margin-top: 30px;
  cursor: pointer;
}

.emptext {
  font-size: 40px;
  font-weight: 600;
  color: #34c0be;
  padding-right: 10px;
}

.empselect {
  color: #646464;
  width: 82px;
  font-weight: 500;
  font-size: 14px;
}

.header.header3 {
  padding-bottom: 0px;
}

.permission-alert-msg {
  background-color: #f8d7da;
  padding: 1rem 1rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
  font-weight: 600;
  color: #842029;
  border: 1px solid transparent;
  border-radius: .25rem;
  border-color: #f5c2c7;
}
span.filter-text {
  font-weight: 600;
  color: #34c0be;
  font-size: 14px;
  float:right;
  cursor: pointer;
}
.heading{
  margin-top: 25px;
}
.subHeading{
  margin-top: -10px;
}
.selectedComp {
  display: flex;
  flex-wrap:wrap;
  margin-top: 5px;
}
.selected{
  padding: 8px 10px;
  margin: 3px;
  border-radius: 10px;
  background-color: #5d409f;
  color: #fff;
  text-align: center;
  display: inline-block;
  img {
    padding-left: 5px;
    height: 20px;
    width: 30px;
    top: 1px;
    position: relative;
  }
}
.rect {
  padding: 8px 10px;
  margin: 3px;
  border-radius: 10px;
  background-color: #aeaeae;
  color: #fff;
  text-align: center;
  display: inline-block;
  img {
    padding-left: 10px;
    top: 4px;
    position: relative;
  }
}
span.tag-title {
  position: relative;
}
.mt-35{
  margin-top: 35px;
}
.span.close-title{
  position: relative;
  top: -4px;
}

</style>
